import React, { Suspense } from 'react';
import { FaRegListAlt } from 'react-icons/fa';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import InOutMaterialHeader from './inventory/in-out-material/InOutMaterialHeader';
import { getInOutMaterials } from 'redux/erp/inventorySlice';
import { useAgGrid } from 'hooks/useAgGrid';

const LazyInOutMaterialList = React.lazy(() => import('./inventory/in-out-material/InOutMaterialList'));

const InOutInventoryMaterials = () => {

  const {
      gridRef,
      gridApi,
      onGridReady,
      refreshGrid,
      addRow,
      clearAll,
      currentParams,
      updateCustomParams
    } = useAgGrid(getInOutMaterials);

  return (
    <>
      <InOutMaterialHeader
        currentParams={currentParams}
        refreshGrid={refreshGrid}
        clearFilter={clearAll}
        addRow={addRow}
      />

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <FaRegListAlt size={13} />,
              content: (
                <Suspense fallback={<LoadingSpinner message="Loading..." />}>
                  <LazyInOutMaterialList
                    gridRef={gridRef}
                    gridApi={gridApi}
                    onGridReady={onGridReady}
                    clearAll={clearAll}
                    currentParams={currentParams}
                    updateCustomParams={updateCustomParams}
                  />
                </Suspense>
              ),
            },
          ]}
        />
      </Card>
    </>
  )
}

export default InOutInventoryMaterials;
